import Hitachi from '../../assets/companies/hitachi.png';
import Paypal from '../../assets/companies/paypal.png';
import Loreal from '../../assets/companies/loreal.png';
import Unilever from '../../assets/companies/unilever.png';
import Similar from '../../assets/companies/similar.png';
import MyHeritage from '../../assets/companies/my-heritage.png';
import Sketchers from '../../assets/companies/sketchers.png';
import Netflix from '../../assets/companies/netflix.png';

export const TRUSTED_COMPANIES = [
    {
        id: 'hitachi',
        name: 'Hitachi',
        image: Hitachi,
    },
    {
        id: 'paypal',
        name: 'PayPal',
        image: Paypal,
    },
    {
        id: 'similarweb',
        name: 'Similarweb',
        image: Similar,
    },
    {
        id: 'sketchers',
        name: 'Sketchers',
        image: Sketchers,
    },
    {
        id: 'my-heritage',
        name: 'My Heritage',
        image: MyHeritage,
    },
    {
        id: 'netflix',
        name: 'Netflix',
        image: Netflix,
    },
    {
        id: 'loreal',
        name: "L'Oréal",
        image: Loreal,
    },
    {
        id: 'unilever',
        name: 'Unilever',
        image: Unilever,
    },
];
